export default "__VITE_ASSET__D$UobG32__"